<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1000" v-model="dialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          NHẬP EXCEL <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5 border">
          <div class="wrap">
            <div
              class="d-flex flex-column justify-center align-center mx-auto"
              style="width: 330px; min-height: 320px"
              v-if="step === 'import'"
            >
              <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
              <div class="text-center content-text mt-5">Tải tệp Excel (.xlsx) thông tin lương giáo viên</div>
              <div class="mt-5">
                <v-btn color="primary" class="mr-5" outlined @click="exportExcelTemplate">Tải mẫu nhập</v-btn>
                <v-btn color="primary" class="elevation-0 white--text" :loading="isSelecting" @click="onExcelUpload">
                  <span class="white--text">Chọn tệp</span>
                  <input
                    ref="uploader"
                    type="file"
                    class="d-none"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="onFileChanged"
                  />
                </v-btn>
              </div>
            </div>
            <TablePreviewSalary v-else :items="items" />
          </div>
        </v-card-text>
        <hr color="#E0E0E0" />
        <v-card-actions>
          <v-btn class="ma-2" width="100px" outlined light depressed @click="cancel">Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="step === 'send'" class="ma-2" width="100px" color="primary" @click="onConfirm">Lưu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import TablePreviewSalary from './TablePreviewSalary.vue'
import { SalaryReport } from '@/plugins/api'
import { mapActions } from 'vuex'
import { get } from 'lodash'

export default {
  components: { TablePreviewSalary },
  data() {
    return {
      dialog: false,
      isSelecting: false,
      selectedFile: null,
      step: 'import',
      items: [],
    }
  },
  computed: {},
  methods: {
    ...mapActions({
      fetchReports: 'salaryReport/fetchReports',
    }),
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },

    reset() {
      this.step = 'import'
      this.items = []
    },
    async onConfirm() {
      try {
        this.$loading.active = true
        await SalaryReport.createMany({ data: this.items, periodId: this.$route.params.id })
        await this.fetchReports({ period: this.$route.params.id, _limit: 10, _start: 0 })
        this.$alert.success('Tải file thành công')
        this.cancel()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    exportExcelTemplate() {
      this.$loading.active = true
      window.location.href = `${window.location.origin}/Mẫu nhập tổng kết lương GV.xlsx`
      this.$loading.active = false
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true },
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {})
      } catch (error) {
        this.$alert.error({
          title: 'File không có định dạng.',
          description: 'xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)',
        })
        return
      } finally {
        this.$loading.active = false
      }
      // readFileResult.splice(0, 2)
      const names = readFileResult[0]
      readFileResult.shift()
      const result = []
      readFileResult.forEach(item => {
        const data = {
          sumFees: [],
          minusFees: [],
          taxFees: [],
        }
        names.forEach((name, index) => {
          let value = Math.floor(item[index])
          if (isNaN(value)) value = 0
          switch (name) {
            case 'Mã GV':
              data.code = item[index]
              break
            case 'Tên GV':
              data.name = item[index]
              break
            case 'Tổng thu nhập':
              data.totalBeforeTax = value
              break
            case 'Thu nhập sau thuế':
              data.totalAfterTax = value
              break
            case 'Giảm trừ tính thuế TNCN':
            case 'Thu nhập chịu thuế':
              if (value > 0) data.taxFees.push({ name: name, value })
              break
            case 'Thuế tính theo khung':
              data.totalTax = value
              break
            default:
              if (typeof name === 'string' && name.length) {
                if (!this.excludeColumnName(name)) {
                  if (value < 0) data.minusFees.push({ name, value })
                  if (value > 0) data.sumFees.push({ name, value })
                }
              }
              break
          }
        })

        const taxFees = this.genTaxFees(data)
        result.push({ ...data, taxFees, id: Date.now().toString() + data.code })
      })
      this.items = result
      this.step = 'send'
      this.$loading.active = false
    },
    excludeColumnName(name = '') {
      if (name.toLowerCase().includes('dư nợ')) return true
      if (name.startsWith('Đã chi')) return true
      return false
    },
    genTaxFees(doc = {}) {
      const oldTaxFees = get(doc, 'taxFees', [])
      let taxFees = [{ name: 'Tổng thu nhập', style: 'b', value: doc.totalBeforeTax }]
      const subTax = oldTaxFees.find(t => t.name === 'Giảm trừ tính thuế TNCN')
      taxFees.push({
        name: 'Giảm trừ tính thuế TNCN',
        value: get(subTax, 'value', 0),
      })
      const painTax = oldTaxFees.find(t => t.name === 'Thu nhập chịu thuế')
      taxFees.push({
        name: 'Thu nhập tính thuế (Tổng thu nhập - giảm trừ)',
        value: get(painTax, 'value', 0),
      })
      taxFees.push({
        name: 'Thuế TNCN phải đóng',
        style: 'b',
        value: doc.totalTax,
      })
      taxFees.push({ name: 'Tổng thu nhập sau thuế', value: doc.totalAfterTax })
      return taxFees
    },
  },
}
</script>
<style>
.wrap {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 4px;
}
</style>
